import { REMIND_MAIL_SUBJECT, REMIND_MAIL_FORM, REMIND_MAIL_SENDER_ADDRESS } from '@/remindModule/constants';
import { IResponse } from '@/appLogic/leanpath/interfaces';
import { getUserId } from '@/awsCodes/awsUtils';
import { getReminderByDate } from '@/businessRepository/reminderTable/dataAccess';
import { createReminder, updateReminder } from '@/businessRepository/reminderTable/driver';
import { IDate } from '@/coreDomainsModule/date';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { ReminderInfoService } from './domains/services/reminderInfoService';
import { IUserService } from '@/coreDomainsModule/services/userService';

/**
 * リマインドメール情報の登録
 * @param dateValue - リマインド登録を行う日付情報
 * @param business - 取引情報
 */
export const saveReminderMailInfo = async (dateValue: Date, business: IBusiness): Promise<IResponse | undefined> => {
  // 送信先メールアドレス指定
  const mailTo: string[] = await IUserService.getOrganizationUserEmail(); // 組織に登録しているユーザーのメールアドレス
  const userId: string = getUserId();
  const subject = REMIND_MAIL_SUBJECT; // デフォルトの件名
  const defaultMailForm = REMIND_MAIL_FORM; // デフォルトのメールフォームテキスト
  const mailSender = REMIND_MAIL_SENDER_ADDRESS; // リマインド用の送信元アドレス

  // 組織に登録しているユーザーのメールアドレスが空だったら
  if (mailTo.length === 0) {
    // TODO: エラーモーダルを出した方が良いかも
    console.error('Failed to obtain an email address for your organization.');
    return;
  }

  let mailForm = defaultMailForm + '------------------\n'; // フォームテキスト格納用

  const receiveDate: IDate = DateService.convertDateToIDate(dateValue);

  // YYYYMMDDの8桁のstring型の年月日情報に変換する
  const dateString: string = DateService.convertIYearMonthDayToYYYYMMDD(receiveDate);
  // TODO: メール送信先配列の先頭にリマインド登録者のアドレスがある想定で書いている。Bcc機能が追加されたら変更する
  const remindMailArr = (await getReminderByDate(dateString)).filter((ent) => ent.mailTo[0] === userId);

  if (remindMailArr.length === 0) {
    // 登録済みリマインダーが無い場合
    // デフォルトのリマインダーフォームテキストに発注情報を記載する
    mailForm += ReminderInfoService.createOrderInfoFormText(business);

    // リマインダーの新規登録
    // TODO: エラーハンドリング
    const res = await createReminder(dateString, mailTo, mailSender, subject, mailForm);
    return res;
  } else {
    // 登録済みリマインダーがある場合
    // 登録済みリマインダーのフォーム情報に、今回追加する発注情報を記載する
    mailForm = remindMailArr[0].mailBody + '\n\n\n\n' + ReminderInfoService.createOrderInfoFormText(business);
    const dataId = remindMailArr[0].dataId; // 登録済みリマインダーのID

    // リマインダーの更新・登録
    // TODO: エラーハンドリング
    const res = await updateReminder(dataId, dateString, mailTo, mailSender, subject, mailForm);
    return res;
  }
};
